import { useDirectPayContext } from '../context/DirectPayContext'
import { AccountProvider } from '../../../../../graphql/generated/graphql'

export const useWalletAction = () => {
    const { account, fullAccount } = useDirectPayContext()
    const isPayOthers = !account.ownedByUser

    if (fullAccount?.__typename === 'CheckbookVirtualCard') return 'Fund with'
    if (isPayOthers || account.provider !== AccountProvider.Checkbook) return 'Pay with'
    return 'Off-ramp'
}
